module.exports = __webpack_public_path__ + "static/img/Newplanet.a956a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Newplanet.png
// module id = lO1W
// module chunks = 46